export type TranslationRulesId = string;

export type TranslationKey = string;

export type TranslationText = string;

export type LanguageTranslations = Record<TranslationKey, TranslationText>;

export type LanguageKey = string;

export type Translations = Record<
  LanguageKey,
  { translation: LanguageTranslations }
>;

export enum TranslationOverrideType {
  PUBLIC = 'PUBLIC',
  PREVIEW = 'PREVIEW',
}

export interface TranslationItem {
  key: TranslationKey;
  translations: Record<LanguageKey, TranslationText>;
}

export enum TranslationRulesClient {
  WEB = 'WEB',
  INSTORE = 'INSTORE',
}

export interface TranslationRules {
  id: TranslationRulesId;
  name?: string;
  client?: TranslationRulesClient;
  rulesFileURL?: string;
  rulesPreviewFileURL?: string | null;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  publishedAt?: Date | string;
}
